const ru = {
    demo: {
        title: 'Russian',
        introduction:
            'Lorem Ipsum - это текст-"рыба", часто используемый в печати и веб-дизайне. Lorem Ipsum является стандартной "рыбой" для текстов на латинице с начала XVI века.',
    },
    docs: {
        hi: 'Привет',
        description:
            'Нужна помощь? \n Пожалуйста, ознакомьтесь с нашей документацией.',
        documentation: 'документация',
    },
    app: 'Приложение',
    user: 'Пользователь',
    list: 'Список',
    edit: 'Редактировать',
    save: 'Сохранить',
    shop: 'Магазин',
    blog: 'Блог',
    post: 'Пост',
    mail: 'Почта',
    chat: 'Чат',
    cards: 'Карточки',
    posts: 'Посты',
    create: 'Создать',
    kanban: 'Канбан',
    general: {
        "your menus": "Ваши Меню",
        "don't forget to set up": "Не забудь настроить",
        "skip_add_to_cart": "Заказ через добавление в корзину",
        "allow_payment_points": "Разрешить оплату баллами",
        "order_via_leadform": "Отключить кнопки Купить",
        "public_offer_link": "Ссылка на оферту",
        "policy_link": "Ссылка на политику",
        "only_latin_letters_no_spaces": "Только латинские буквы без пробелов",
        "agreements_link": "Согласие на обработку пперсональных данных",
        "requisites_link": "Ссылка на реквизиты",
        "what_to_do_here": "Как настроить этот раздел?",
        "goods": "Товары",
        "orders": "Заказы",
        "payments": "Платежные системы",
        "accepting payment": "Приём оплаты",
        "deliveries": "Способы Доставки",
        "Button to the application in the pinned message of the channel": "Кнопка на приложение в канале",
        "how add usercard": "Как настроить главную страницу/визитку",
        "pin_button_usercard": "Кнопка на визитку в канале/чате",
        "how to publish an app": "Как опубликовать приложение",
        "How_to_great_page": "Как создать великолепную страницу",
        "how to add a product": "Как добавить товар в приложение",
        "how_create_forms": "Как создать форму",
        "desc publish tma": "Как опубликовать приложение чтобы оно запускалось в канале или других чатах и диалогах",
        "how to pin": "Как закрепить кнопку в telegram канале или чате на ваше приложение",
        "how to products": "Как создать, отредактировать и настроить товары в вашем приложении",
        "about usercard": "Сделайте привлекательную главную страницу вашего приложения - визитку",
        "find_out_all_the_tips": "Узнайте все советы по созданию внутренних страниц вашего приложения",
        "how_use_builder_forms": "Узнайте, как пользоваться конструктором форм и как добавлять формы на страницы",
        "payment system": "Платежная система",
        "Show in list": "Показывать в списке",
        "Add images": "Добавить изображения",
        "Add image": "Добавить изображение",
        "Do after pay goods": "Действия после оплаты товара",
        "Message after buy": "Сообщение после оплаты",
        "sale_label": "Красная метка",
        "new_label": "Зеленая метка",
        "title_cannot_be_empty": "Название не может быть пустым",
        "price_must_be_number": "Цена должна быть числом",
        "you_can_use_markdown_markup": "Можно использовать разметку Markdown",
        "telegraph_link": "Укажите ссылку на Вашу статью в telegra.ph",
        "write_word_group_products_into_category": "Напишите любое слово, и используйте его у товаров, которые относятся к этой категории",
        "line_through": "Зачеркнутая строка",
        "discount": "Скидка",
        "what_need_for_create_product": "Для создания товара достаточно указать «Название» и «Цену Продажи»",
        "what_need_for_create_page": "Для создания страницы достаточно указать «Название» и ссылку на статью telegra.ph",
        "set_message_in_bot": "Установить сообщение в боте",
        "access_for_subscribers": "Доступ только для подписчиков",
        "_text_about_pages": "Страницы создаются на базе статей telegra.ph. Notibot может преобразовать обычную статью telegra.ph в великолепную страницу с кнопками , формами , красивыми списками и т.д.",
        "_text_about_pages_2": "Сделайте ваше приложение еще функциональнее с помощью продвинутых страницы. Добавляйте кнопки , формы , видео , галереи и другиие элементы",
        "_text_about_tools": "Бизнес инструменты, расширяющие функционал вашего приложения. Благодаря им, взаимодействие клиентов с вашим приложением выйдет на новый уровень ",
        "_text_about_forms": "Используйте конструктор форм для сбора заявок, анкет, опросов, тестов и тд. Ниже список ваших форм с аналитикой (сколько человек увидело форму/сколько человек заполнили форму)",
        "_text_about_start_shop": "Для быстрого старта просто добавьте товар и настройте приём оплат. Используйте кнопку «Предпросмотр», чтобы увидеть, как будет выглядеть приложение",
        "_text_about_settings": "Сделайте ваше приложение еще более продвинутым, оплатив Тариф в разделе «Оплата». Рекомендуйте notibot и зарабатывайте вместе с нами, следите за рефералми в разделе «Рефералы»",
        "_text_about_chatbot": "Увеличивайте продажи без дополнительных затрат на рекламу, благодаря рассылкам по подписчикам и автосообщениям.",
        "_text_about_automessages": "Настройте сообщение, которое клиент получит сразу после открытия приложения или запуска бота. Запускайте отложенные серии сообщений, в зависимости от того какую страницу/товар открыл пользователь. Отправляйте сообщения если пользователь посмотрел товар, но не купил его и т.д. ",
        "payment_system_description": "Чтобы принимать оплаты в магазине необходимо подключить способы оплаты",
        "payment_system_title": "Платежные системы",
        "how_self_link": "Чтобы указать ссылку на внутреннюю страницу созданную в notibot , напишите /post#ID_страницы ",
        "how_metrika_id": "Укажите только ID счетчика метрики",
        "ya_metrika": "Яндекс.Метрика",
        "appname_botfather": "Имя для приложения для Botfather",
        "how_appname": "только латинские буквы без пробелов и прочих симовлов (по умолчанию aboutme). Незабудьте добавить Direct Link для вашей app в @botfather",
        "change tariff": "Сменить тариф",
        "automatic_payment": {
            "title": "Автоматическая оплата",
            "text_manual": "Укажите ссылку в кабинете",
            "url": "https://api.notibot.ru/",
            "yoomoney": "ЮMoney",
            "prodamus": "Prodamus",
            "yookassa": "ЮKassa",
            "robokassa": "Робокасса",
            "leadpay": "LeadPay",
            "otherbank": "Другие банки",
            "login": "Логин",
            "password": "Пароль",
            "password2": "Пароль 2",
            "wallet_number": "Номер кошелька",
            "url_form": " Ссылка на форму оплаты",
            "secret_key": "Секретный ключ",
            "login_lower_case": "логин",
            "password_lower_case": "пароль",
            "password2_lower_case": "пароль 2",
            "wallet_number_lower_case": "номер кошелька",
            "url_form_lower_case": " ссылка на форму оплаты",
            "secret_key_lower_case": "секретный ключ",
            "payment_yoomoney_description": "Укажите номер кошелька и секретный ключ из кабинета ЮMoney",
            "payment_prodamus_description": "Укажите ссылку на форму оплаты и секретный ключ из кабинета Prodamus",
            "payment_yookassa_description": "Укажите логин, пароль из кабинета ЮKassa",
            "payment_robokassa_description": "Укажите логин, пароль и пароль 2 из кабинета Робокасса",
            "payment_leadpay_description": "Укажите логин, и Секретный ключ из кабинета LeadPay",
            "gk_description": "Для настройки GetCourse ознакомьтесь с инструкцией",
            "tbank": "Т-Банк",
            "tochka": "Точка Банк",
            "terminal": "Терминал",
            "payment_tbank_description": "Укажите пароль и терминал из кабинета Т-Банк",
            "specify_the_type_of_VAT": "Укажите тип НДС, если у Вас подключена онлайн-касса, и вы выдаете чеки при покупке",
            "electronic_checks_RF": "Электронные чеки (РФ)",
            "taxation_regime_RF": "Режим налогообложения (РФ)",
            "amo_description": " Для настройки интеграции с amoCRM нажмите на кнопку и следуйте инструкции в открывшемся окне "
        },
        "manual_payment": {
            "title": "Ручные способы оплаты",
            "text_manual": "Здесь вы можете настроить текстовые инструкции для оплаты. Они используются, когда нет интеграции с платежными системами.",
            "sber": "Сбербанк",
            "alfabank": "Альфа-Банк",
            "tinkoff": "Т-Банк",
            "sbp": "СБП",
            "otherbank": "Другие банки",
            "leadform": "Оставить заявку"
        },
        "integration": {
            "title": "Интеграция",
            "gk": "Гет Курс",
            "amo": "amoCRM",
            "connect_amocrm": "Интеграция с amoCRM",
            "bitrix": "Bitrix"
        },
        "instruction": {
            "instruction": "Инструкция",
            "how_to_set_up_integration": "Как настроить интеграцию"
        },
        "affiliate": {
            "title": "Партнерская программа"
        },
        "copy_from": "Для того чтобы скопировать данную форму другому пользователю, отправьте своему боту команду ",
        "copy_page_or_product": "Для того чтобы скопировать данную страницу или товар другому пользователю, отправьте своему боту команду ",
        "replace_with_copied_code": "Необходимо  {code} заменить на скопированный код"
    },
    banking: 'Банкинг',
    booking: 'Бронирование',
    profile: 'Профиль',
    account: 'Аккаунт',
    product: {
        benefit: 'выгода',
    },
    invoice: 'Счет',
    details: 'Детали',
    checkout: 'Оформление',
    calendar: 'Календарь',
    analytics: 'Аналитика',
    ecommerce: 'Электронная коммерция',
    management: 'Управление',
    menu_level: 'Уровень меню',
    menu_level_2a: 'Уровень меню 2a',
    menu_level_2b: 'Уровень меню 2b',
    menu_level_3a: 'Уровень меню 3a',
    menu_level_3b: 'Уровень меню 3b',
    menu_level_4a: 'Уровень меню 4a',
    menu_level_4b: 'Уровень меню 4b',
    item_disabled: 'Элемент отключен',
    item_label: 'Элемент с меткой',
    item_caption: 'Элемент с подписью',
    item_external_link: 'Внешняя ссылка',
    description: 'Описание',
    other_cases: 'Другие случаи',
    item_by_roles: 'Элемент по ролям',
    only_admin_can_see_this_item: 'Только админ может видеть этот элемент',
    dashboard: 'Дашборд',
    auth: {
        logout: 'Выйти',
        tech_support: 'Тех. поддержка',
    },
    banners: {
        practicum: {
            title: 'Практикум',
            description: 'Обучающие материалы и практические задания для эффективной работы.',
            button: 'Перейти',
        },
        news: {
            title: 'Новости',
            description: 'Последние обновления, новости и важные объявления.',
            button: 'Читать',
        },
    },
    companies: {
        name_company: 'Название магазина',
        edit_shop: 'Редактировать магазин',
        shops_list: 'Список магазинов',
        add_shop: 'Добавить магазин',
        set_manager: 'Назначить менеджера',
        time_working: 'Время работы',
        token_tg: 'Токен Telegram',
        your_companies: 'Ваши магазины',
    },
    employees: {
        calculate_wage: 'Рассчитать зарплату',
        self: 'Сотрудники',
    },
    games: {
        leaderboard: {
            balance: 'Баланс',
            referral: 'Реферал',
        },
    },
    qs: {
        One_company: 'Одна компания',
        One_service: 'Одна услуга',
        One_staff: 'Один сотрудник',
        at_least: 'Как минимум',
        first_add: 'Сначала добавьте',
        name_desc_adr: 'Название, Описание, Адрес',
        name_price_duration: 'Название, Цена, Длительность',
        namestaff_specialization: 'Имя, Сотрудник, Специализация',
        open_recording_set_time: 'Откройте запись, Установите время',
        set_staff_schedule: 'Установите расписание сотрудников',
        staff_service: 'Услуга сотрудника',
        to_staff: 'Сотруднику',
    },
    services: {
        self: 'Услуги',
    },
    system: {
        add: 'Добавить',
        address: 'Адрес',
        allowed: 'Разрешено',
        are_you_sure_want_to_delete: 'Вы уверены, что хотите удалить?',
        contacts: 'Контакты',
        copied: 'Скопировано',
        create: 'Создать',
        delete: 'Удалить',
        delete_confirm: 'Вы уверены, что хотите удалить этот курс? Это действие нельзя отменить.',
        description: 'Описание',
        editor: 'Редактор',
        edit: 'Редактировать',
        dashboard: 'Дашборд',
        refresh: 'Обновить',
        draft: 'Черновик',
        published: 'Опубликовано',
        copy_code: 'Код для копирования',
        local_view: 'Локально',
        miniapp_view: 'Мини-апп',
        access_settings: 'Настройки доступа',
        max_size_of: 'Максимальный размер',
        partners: 'Партнеры',
        save_changes: 'Сохранить изменения',
        selected: 'Выбрано',
        view_all: 'Посмотреть все',
        // Merged from my_ru.json
        "sort by date": "Сортировка по дате",
        newest: "Сначала новые",
        oldest: "Сначала старые",
        back: "Назад",
        select_category: "Выбрать категорию",
        change_category: "Изменить категорию",
        back_to_channel: "Вернуться в канал",
        back_to_list: "Вернуться к списку",
        back_to_cart: "Вернуться в корзину",
        add_to_cart: "в Корзину",
        add_to_order: "Добавить к заказу",
        go_to_order: "К оформлению",
        buy_now: "Купить сейчас",
        cancel: "Отменить",
        exit: "Выйти",
        clear: "Очистить",
        apply: "Применить",
        items: "элементов",
        create_success: "Всё получилось!",
        create_fail: "Что-то пошло не так!",
        update_success: "Обновили, всё хорошо!",
        Save: "Сохранить",
        save: "Сохранить",
        saving: "Сохраняем...",
        short_description: "Короткое описание",
        "copy created": "Копия создана!",
        "create copy": "Создать копию",
        copy: "Скопировать",
        search: "Найти...",
        search_by_name_or_phone: "Поиск по имени или номеру телефона...",
        items_selected: "Выбрано записей",
        logout: "Выход",
        home: "Главная",
        unable_to_logout: "Невозможно выйти!",
        profile: "Профиль",
        settings: "Настройки",
        integrations: "Интеграции",
        active: "Активна",
        dont_active: "Неактивна",
        max_files_of: "макс. количество файлов",
        upload_files: "Загрузите файлы",
        upload_to_server: "Загрузить на сервер",
        pay: "Перейти к оплате",
        email_must_be_a_valid_email_address: "Некорректный Email",
        phone_is_required: "Телефон обязательное поле",
        email_is_required: "Email обязательное поле",
        firstname_name_is_required: "Имя обязательное поле",
        Add_event: "Новое событие",
        Edit_event: "Редактировать событие",
        results_found: "объектов найдено",
        Colors: "Цвета",
        Date: "Дата",
        Events: "События",
        enter_number_value: "Укажите числовое значение",
        enter_percent_value: "Укажите количество процентов от 0 до 100",
        current_she: "текущая",
        subscribers: "Подписчики",
        newsletter: "Рассылка",
        close: "Закрыть",
        minutes: "минуты",
        hours: "часы",
        article: "Статья",
        articles: "Статьи",
        product: "Товар",
        form: "Форма",
        action: "Действие",
        condition: "условие",
        conditions: "условия",
        open: "Открыл",
        Open: "Открыть",
        do_not_open: "Не открыл",
        fill: "Заполнил",
        did_not_fill: "Не заполнил",
        bought: "Купил",
        did_not_buy: "Не купил",
        pages: "Страница",
        add_page: "Добавить страницу",
        add_product: "Добавить товар",
        header: "Заголовок",
        subheader: "Подзаголовок",
        to: "до",
        send: "Отправить",
        "withdraw ": "Вывести ",
        finalize_order: "Завершить заказ",
        finalize: "Завершить",
        share: "Поделиться",
        files: "файлов",
        are_you_sure: "Вы уверены?",
        delete_confirmation_content: "Вы уверены, что хотите удалить {{count}} записей?",
        there_is_no_information_here_yet: "Здесь пока нет информации",
        basket: "Корзина\\",
        "1_month": "1 мес.",
        "1_year": ">1 год.",
        "3_month": "3 мес.",
        "6_month": "6 мес.",
        bot_subscribers: "Подписчики бота",
        read_more: "Подробнее",
        filter: "Отфильтровать",
        categories: "Категории",
        access_open: "Доступ открыт",
        access_close: "Доступ закрыт",
        be_opened: "откроется",
        be_closed: "закроется",
        time_left: "осталось",
        left_days: "дней",
        left_hours: "часов",
        left_minutes: "минут",
        left_seconds: "секунд",
        link_need_http: "Ссылка должна начинаться с http:// или https://",
        button: "Кнопка",
        status: "Статус",
        complete_order_soglasie: "Я согласен на [обработку персональных данных]({{agreements_link}})",
        complete_order_agreement: "Нажимая кнопку \"Завершить заказ\" я соглашаюсь с [Договором оферты]({{public_offer}}) и [политикой конфиденциальности]({{policy_link}})",
        fill_in_data: "Заполните данные",
        select_action: "Выберите действие"
    },
    payment: {
        self: "Оплата",
        pay_to: "Оплатить",
        monthly: "на месяц",
        mo: "мес",
        popular: "Популярно",
        usercard: "Визитка",
        basic: "Базовый",
        premium: "Pro",
        starter: "Free",
        unlim: "Под ключ",
        current_plan: "Текущий тариф",
        pay_basic: "Оплатить Базовый",
        pay_premium: "Оплатить Pro",
        pay_unlim: "Оплатить Под ключ",
        yearly: "На Год",
        saving: "экономия 40% при оплате на год",
        saving_yearly: "Экономия {price}₽ при оплате за год",
        saving_price: "Экономия {price}₽",
        tariff: "Тариф",
        total_billed: "Итого",
        total_billed_price: "к оплате {price}₽",
        amount: "Сумма",
        main_screen_catalog: "Главный экран только Каталог",
        vitrina_app: "Приложение Магазин",
        launch_from_any_dialog: "Запуск приложения из любого диалога",
        autosubscription_on_start: "Автоподписка в чат-бот при запуске",
        "10_goods_5_articles": "10 товаров и 5 страниц",
        "5_goods_5_articles": "5 товаров и 5 страниц",
        goods_cart: "Корзина товаров",
        manual_payment_methods: "Ручные способы оплаты",
        manual_orders: "Ручной приём заказов",
        order_notifications: "Уведомления о заказе админу и клиенту",
        subscriber_access_only: "Проверка подписки на канал",
        telegraph_integration: "Интеграция с Telegraph",
        standard_launch_button: "Стандартная кнопка запуска в канал/чат",
        integration_with_vk: "Интеграция с вк",
        application_in_telegram_bot: "Применение в telegram-боте",
        telegram_bot_for_booking: "Telegram-бот для бронирования",
        integration_with_clients: "Интеграция с клиентами",
        main_screen_catalog_vizitka: "Главный экран: Каталог и Визитка",
        everything_in_vitrina: "Всё, что есть в тарифе Free",
        "50_goods_20_articles": "50 товаров и 20 страниц",
        "500_goods_100_articles": "500 товаров и 100 страниц",
        "Pro blocks usercard": "PRO блоки в визитке",
        "Pro blocks articles": "PRO блоки в страницах",
        active_users: "активных пользователей в рассылке",
        "white label": "Отключение подписи «Работает на Notibot»",
        "when paying for a year": "при оплате на год",
        "payment by points": "Оплата ваших товаров баллами",
        vizitka_app: "Приложение ВИЗИТКА",
        "10_review_gallery_photos": "10 фото в галерее отзывов",
        "10_portfolio_photos": "10 фото в портфолио",
        custom_launch_button: "Настраиваемая кнопка запуска в канал/чат",
        launch_button_article: "Кнопка в закрепе может запускать отдельную статью",
        min_landing_pages: "Мини лендинги из статей Telegraph",
        everything_in_vitrina_basic: "Всё из предыдущих тарифов",
        vitrina_vizitka_auto_payments_mailings: "Витрина/Визитка/Автоплатежи/Рассылки",
        subscriber_marketing_emails: "маркетинговые электронные письма подписчикам",
        mailings_for_all_users: "Рассылки по всем кто запускал приложение",
        auto_notify_book_reminder: "Автоматический прием оплат",
        automatic_payment_receipt: "Автоматический прием оплат",
        integration_with_prodamus: "Интеграция с Продамус/Робокасса/Leadpay/Юкасса/Юмани...",
        integration_with_tbank: "Интеграция с Т-Банк",
        integration_with_crm: "Интеграция с АмоCRM / ГетКурс",
        built_in_response_app: "Встроенное приложение для ответов",
        launch_button_specific_article: "Кнопка в закрепе может запускать отдельную статью",
        min_landing_pages_telegraph: "Мини лендинги из статей Telegraph",
        application_forms: "Формы сбора заявок",
        quizzes_tests_surveys: "Квизы / Тесты / Викторины",
        quizzes: "Формы-Квизы",
        tests_surveys: "Тесты / Викторины",
        tests_surveys_ai: "Генерация тестов и викторин с помощью ИИ",
        "number of administrators": "Кол-во администраторов",
        "dedicated support line": "Отдельная линия поддержки",
        "short codes": "Шорткоды (таймеры/ и пр блоки для автоворонки)",
        "chatbot and automation": "Чат-бот и автоматизация",
        gamification: "Геймификация (система баллов и др.)",
        "wheels of fortune": "Колесо фортуны",
        club: "Клуб (Канал/чат по подписке)",
        "referral program": "Реферальная программа",
        "connecting personal account": "Подключение к личному аккаунту",
        courses_marathons_web3: "Курсы/марафоны/Автоворонка Web 3.0",
        segmented_mailings: "Сегментированные рассылки",
        book_confirmation: "Подтверждение бронирования",
        invitation_for_return_visits: "Приглашение на повторный визит",
        dealing_with_lost_clients: "Работа с потерянными клиентами",
        feedback_request: "Запрос на отзыв",
        interception_of_negative_reviews: "Перехват негативных отзывов",
        we_will_create_app_for_you: "Сделаем приложение за Вас",
        we_will_set_up_and_connect_everything: "Всё настроим всё подключим",
        provide_video_instructions: "Дадим видео инструкции",
        unlim_tariff_included: "Включен Тариф ПРИЛОЖЕНИЕ на 1мес или 1год",
        priority_support_one_month: "1 месяц приоритетная поддержка",
        integration_with_yclients: "",
        integration_with_viber: "Интеграция с Viber",
        more_about_the_tariff: "Подробнее о тарифе",
        successful_tariff_payment: "Успешная Оплата тарифа",
        tariff_payment_error: "Ошибка оплаты тарифа"
    },
    courses: {
        video_unsupported: 'Неподдерживаемый формат ссылки на видео',
        video_supported_formats: 'Поддерживаемые форматы: YouTube, VK, Rutube, Dzen, Yandex Cloud, Kinescope, plvideo',
        no_forms_found: 'Форм не найдено',
        search_form: 'Поиск формы',
        select_form: 'Выбрать форму',
        connect_form: 'Подключить форму',
        connect_form_desc: 'Выберите существующую форму, чтобы назначить её как домашнее задание.',
        all_forms: 'Все формы',
        quiz_forms: 'Тесты',
        regular_forms: 'Обычные формы',
        reset_form: 'Сбросить форму',
        selected_form: 'Выбранная форма',
        unlock_requirement: 'Условие доступа (Урок, открывающий доступ)',
        previous_lesson_required: 'Пользователь должен пройти этот урок сначала',
        no_prerequisite: 'Без условий (Урок доступен всегда)',
        courses_page_title: "Курсы",
        import_structure: "Импорт структуры",
        import_title: "Импорт структуры курса",
        import_tab_input: "Ввод / Файл",
        import_tab_preview: "Предпросмотр",
        import_hint: "Загрузите файл (JSON, TXT, Markdown, CSV) или вставьте готовый текст со структурой модулей и ссылками на видео.",
        upload_file: "Загрузить файл",
        sample_md: "Пример Markdown",
        sample_json: "Пример JSON",
        start_import: "Импортировать",
        importing: "Импорт...",
        import_starting: "Начало импорта...",
        creating_module: "Создание модуля",
        creating_lesson: "Создание урока",
        import_success: "Структура курса успешно импортирована",
        tariffs: "Тарифы",
        cohorts: "Потоки",
        curriculum: "Программа",
        settings: "Настройки",
        design: "Дизайн",
        design_appearance: "Внешний вид",
        theme_mode: "Тема оформления",
        primary_color: "Основной цвет",
        primary_color_hint: "Используется для кнопок, активных элементов и акцентов",
        border_radius: "Скругление углов",
        custom_colors: "Кастомные цвета",
        use_custom_colors: "Использовать свои цвета",
        lesson_card_color: "Цвет карточки урока",
        secondary_text_color: "Второстепенный цвет текста",
        add_tariff: "Добавить тариф",
        add_cohort: "Добавить поток",
        tariff_name: "Название тарифа",
        tariff_price: "Цена",
        access_duration: "Длительность доступа",
        access_type: "Тип доступа",
        duration: "Длительность",
        fixed_dates: "Фиксированные даты",
        months: "месяцев",
        days: "дней",
        hours: "часов",
        years: "лет",
        forever: "Навсегда",
        start_date: "Дата начала",
        end_date: "Дата окончания",
        sales_start: "Старт продаж",
        sales_end: "Конец продаж",
        flow_dates: "Даты потока",
        sales_window: "Окно продаж",
        sales_window_hint: "Если не заполнено — будет равно датам потока",
        date_range: "Период действия",
        cohort_name: "Название потока",
        modules_access: "Доступ к модулям",
        all_modules: "Все модули",
        save_tariff: "Сохранить тариф",
        save_cohort: "Сохранить поток",
        delete_tariff: "Удалить тариф",
        delete_cohort: "Удалить поток",
        tariff_prices_for_cohort: "Цены тарифов для этого потока",
        copy_tariffs_from_template: "Скопировать тарифы из шаблона",
        configure_tariffs: "Настроить тарифы",
        base_price: "Базовая цена",
        // Validation
        title_required: "Название обязательно",
        desc_required: "Описание обязательно",
        price_positive: "Цена должна быть положительной",
        close: "Закрыть",
        // Tabs
        basic_info: "Основное",
        design_appearance: "Оформление курса",
        theme_mode: "Тема",
        primary_color: "Основной цвет",
        border_radius: "Радиус скругления",
        custom_colors: "Пользовательские цвета",
        // Info
        course_title: "Название курса",
        description: "Описание",
        cover_image: "Обложка",
        image_placeholder: "Загрузка изображения",
        // Settings
        category: "Категория",
        published: "Опубликован",
        pricing: "Стоимость",
        create_course: "Создать курс",
        save_changes: "Сохранить",
        // Curriculum
        lessons: "Уроки",
        lesson_title: "Название урока",
        module_title: "Название модуля",
        add_lesson: "Добавить урок",
        add_module: "Добавить модуль",
        // Views
        new_course: "Новый курс",
        create_new_course: "Создать новый курс",
        edit_course: "Редактировать курс",
        search_course: "Найти курс...",
        preview: "Предпросмотр",
        students: "студентов",
        // Access Rules
        access_opens: "Доступ открывается",
        access_closes: "Доступ закрывается",
        immediately: "Сразу после оплаты",
        specific_date: "Точно в указанную дату",
        days_after_payment: "Через Х дней после оплаты",
        never: "Никогда",
        days_after_opening: "Через Х дней после открытия",
        days_label: "дней",
        // Lesson Editor
        video_content: "Видео контент",
        video_url: "Ссылка на видео (YouTube / Yandex Video / Kinescope)",
        upload_video: "Загрузить видео",
        lesson_content: "Контент урока",
        quiz_tasks: "Квиз / Задания",
        discussions: "Обсуждения",
        transcript_notes: "Транскрипт и заметки",
        transcript: "Транскрипт",
        attached_files: "Прикрепленные файлы",
        add_file: "Добавить файл",
        quiz_coming_soon: "Компонент редактора квизов скоро появится",
        loading: "Загрузка...",
        timecodes: "Таймкоды",
        conspectus: "Конспект",
        // Completion Settings
        completion_requirement: "Условие прохождения",
        free_access: "Свободный доступ",
        free_access_desc: "Студент может перейти к следующему уроку сразу.",
        timer: "Таймер",
        timer_desc: "Студент должен ждать указанное время.",
        assignment: "Задание",
        assignment_desc: "Студент должен отправить текст или файл.",
        quiz: "Тест",
        quiz_desc: "Студент должен пройти тест.",
        wait_duration: "Время ожидания",
        seconds: "секунд",
        allow_skip: "Разрешить пропуск (Таймер необязателен)",
        required_submissions: "Требования к ответу",
        text_answer: "Текстовый ответ",
        file_attachment: "Прикрепление файла",
        quiz_builder: "Конструктор тестов",
        quiz_builder_desc: "Настройте вопросы, ответы и проходной балл.",
        open_quiz_builder: "Открыть конструктор",
        // Test Builder
        min_passing_score: "Минимальный проходной балл (%)",
        questions: "Вопросы",
        add_question: "Добавить вопрос",
        question_text: "Текст вопроса",
        question_type: "Тип вопроса",
        single_choice: "Один ответ",
        multiple_choice: "Несколько ответов",
        options: "Варианты ответов",
        is_correct_answer: "Правильный ответ?",
        add_option: "Добавить вариант",
        option_placeholder: "Вариант",
        // Types
        type_single: "Один ответ",
        type_multiselect: "Несколько ответов",
        type_true_false: "Правда / Ложь",
        type_fill_blank: "Заполнить пропуск",
        type_ordering: "Упорядочивание",
        type_matching: "Сопоставление",
        type_image_hotspot: "Поиск на изображении",
        // Type specific
        correct_answer_text: "Правильный текст ответа",
        pairs: "Пары",
        left_side: "Левая часть",
        right_side: "Правая часть",
        add_pair: "Добавить пару",
        upload_image_for_hotspot: "Загрузить изображение",
        hotspot_coordinates: "Координаты (x, y)",
        click_to_set_hotspot: "Кликните по изображению, чтобы задать точку",
        // Test Player
        quiz_start_title: "Тест",
        quiz_start_desc: "Проверьте свои знания по теме урока.",
        begin: "Начать",
        result: "Результат",
        correct: "Правильно",
        retry: "Попробовать снова",
        next_lesson: "Следующий урок",
        continue: "Продолжить",
        great_job: "Отличная работа!",
        dont_give_up: "Не сдавайтесь!",
        passed_message: "Вы успешно прошли этот урок.",
        failed_message: "Изучите материал еще раз и попробуйте снова!",
        of: "из",
        // Deadline
        deadline: "Срок выполнения",
        deadline_type: "Тип дедлайна",
        no_deadline: "Без дедлайна",
        relative_deadline: "Относительный (после открытия)",
        fixed_deadline: "Фиксированная дата",
        deadline_days: "Дней",
        deadline_hours: "Часов",
        deadline_date: "Дата дедлайна",
        unit: "Единица измерения",
        minutes: "Минут",
        // AI Generation
        generate_ai: "Создать с AI",
        generate_ai_title: "Сгенерировать тест с помощью ИИ",
        generate_ai_desc: "Опишите тему теста, и ИИ создаст вопросы за вас.",
        topic_label: "Тема теста или текст материала",
        topic_placeholder: "Например: Основы JavaScript, Переменные и Типы данных...",
        generating: "Генерация...",
        assignment_description: "Текст задания",
        check: "Проверить",
        correct_answer: "Верно!",
        wrong_answer: "Неверно",
        correct_is: "Правильный ответ",
        next_question: "Следующий вопрос",
        finish: "Завершить",
        settings_title: "Настройки теста",
        attempts_label: "Попыток прохождения",
        show_correct_label: "Показывать правильный ответ при ошибке",
        time_limit_label: "Время на вопрос (сек)",
        time_limit_hint: "0 = без ограничений",
        time_left: "Осталось",
        no_lessons_yet: "В этом модуле пока нет уроков",
        video_placeholder_desc: "Вставьте ссылку на видео с YouTube, Yandex Video или Kinescope",
    },
    form: {
        required: "Обязательный вопрос",
        incorrect_answer: "Не верный ответ",
        form: "Форма",
        you_have_already_filled_out_the_form: "Вы уже заполнили форму",
        invalid_email_format: "Не верный формат email",
        invalid_phone_format: "Не верный формат номера телефона",
        policy_: "Согласен с условиями использования формы заявки и [политикой конфиденциальности](:link) лица, разместившего форму заявки.",
        policy: "Нажимая кнопку Отправить, Вы даете свое [согласие на обработку персональных данных](:link)",
        agree: "Я согласен на [обработку персональных данных]({{agreements_link}})",
        mailing: "Даю согласие на [получение информационных и маркетинговых рассылок]({:link) (Вы в любой момент можете отказаться от получения писем)",
        agree_2: "Я даю согласие на [обработку персональных данных]({{agreements_link}}) согласно [политике конфиденциальности]({{policy_link}})",
        start_typing: "Начните ввод...",
        details: "Детали",
        phone: "Телефон",
        delivery_method: "Способ доставки",
        address: "Адрес доставки",
        delivery_price: "Стоимость доставки"
    },
    access: {
        page_access: "Доступ к странице",
        select_products_desc: "Выберете товары, которые должны быть куплены у пользователя и интервал в днях, чтобы открылся доступ",
        select_products: "Выбрать товары",
        products: "Товары",
        access_opens_after: "Доступ откроется после покупки",
        days_short: "дн.",
        access_points_price: "Доступ за баллы",
        priority: "Приоритет в списке"
    },
    characteristics: {
        title: "Характеристики",
        name: "Название характеристики",
        type: "Тип характеристики",
        string: "Строка",
        number: "Число",
        add_characteristic: "Добавить характеристику",
        add_value: "Добавить значение",
        edit_value: "Редактировать значение характеристики",
        add_value_title: "Добавить значение к характеристике",
        delete_confirm_title: "Удаление характеристики",
        delete_confirm_content: "Вы уверены, что хотите удалить значение {{value}} у характеристики «{{title}}»?",
        save: "Сохранить",
        cancel: "Отменить",
        characteristic: "Характеристика",
        value: "Значение"
    },
    notify: {
        image_upload: "Загрузка изображения",
        button_text: "Текст на кнопке",
        button_link: "Ссылка на кнопке",
        add: "Добавить"
    },
    pages: {
        title: "Название",
        "dont show header": "Не показывать заголовок",
        "show cover": "Показывать обложку",
        "full width": "На всю ширину",
        "disabled overlay": "Отключить наложение",
        "fullscreen": "Полноэкранный режим",
        "telegram_fullscreen_settings": "Настройки полноэкранного режима Telegram",
        "nav_btn_color": "Цвет кнопок навигации",
        "cover_aspect_ratio": "Соотношение сторон обложки"
    },
    settings: {
        appearance: "Внешний вид",
        select_background_color: "Цвет фона",
        select_text_color: "Цвет текста"
    },
    additional_settings: "Дополнительные настройки"
};

export default ru;
